export default __webpack_public_path__ + "static/media/lista-de-verificacion 1.91db3821.svg";